import React from "react";
import { Trans } from "react-i18next";

const EmailDynamicContentInfo = ({ emailType }) => {
  return (
    <div className="note-text">
      <p>
        <Trans i18nKey="contentCodeMessage">
          You can insert dynamic data into the content by using the following{" "}
          <b>content codes:</b>
        </Trans>
        &nbsp;
        <code>
          {"{{accountName}}, {{accountCode}}, {{toEmail}}, {{button}}"}
          {emailType !== "customer_intro" &&
            emailType !== "promo_email_for_first_time_customer" &&
            ", {{unsubscribe}}"}
          {emailType === "abandoned_cart" && ", {{cartItems}}"}
          {emailType === "promo_email_for_first_time_customer" &&
            ", {{discountpercentage}}"}
        </code>
      </p>
    </div>
  );
};

export default EmailDynamicContentInfo;
